<ng-container *ngIf="loading">
  <div class="container-with-loading">
      <div class="loading-overlay">
          <mat-spinner></mat-spinner>
      </div>
  </div>
</ng-container>

  <mat-card class="offer-card" appearance="outlined" [hidden]="loading">
    <mat-card-content>

      <mat-form-field appearance="outline" style="width:100%">
        <mat-label>Buscar</mat-label>
        <input matInput
               placeholder="Buscar por variable o fórmula"
               (input)="applyFilter($event)">
      </mat-form-field>

      <br>

      <table class="table table-bordered">

        <thead>
          <tr>
            <th>Variable</th>
            <th>Resultado</th>
            <th>Fórmula</th>
          </tr>
        </thead>
      
        <tbody>
          <tr *ngFor="let f of filteredResults">
            <td [innerHTML]="highlight(f.variable)"></td>
            <td>{{f.value}}</td>
            <td [innerHTML]="highlight(f.expression)"></td>
          </tr>
        </tbody>
      
      </table>

    </mat-card-content>
  <mat-card-footer class="general-wf-card-footer">
  </mat-card-footer>
</mat-card>